import React from 'react'
import { connect } from 'react-redux'
import Help from '../../components/utilities/Help'
import { bindActionCreators } from 'redux'
import { showPopup } from '../../actions/uiActions'


class HelpContainer extends React.Component {

    render() {
        return (
            <Help showPopup={this.props.showPopup} />
        )
    }
}

function mapStateToProps(state) {
    return {
    }
}

function mapDispatchToProps(dispatch) {
    return {
        ...bindActionCreators({ showPopup }, dispatch)
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(HelpContainer)